import PropTypes from 'prop-types';
import React from 'react';
import { CoreComponent } from '../../../../../../../framework/component/index';
import CoreContainer from '../../../../../../../framework/container/CoreContainer';
import ComponentFactory from '../../../../../../../framework/factory/ComponentFactory';
import ContainerFactory from '../../../../../../../framework/factory/ContainerFactory';
import CurrencyHelper from '../../../../../../../helper/CurrencyHelper';
import NumberHelper from '../../../../../../../helper/NumberHelper';
import OrderItemService from '../../../../../../../service/sales/order/OrderItemService';

class CreateShipmentItemSeparatelyShipBundleComponent extends CoreComponent {
  static className = 'CreateShipmentItemSeparatelyShipBundleComponent';

  constructor(props) {
    super(props);
    let order = props.order;
    let shipmentItem = props.shipmentItem;
    let orderItem = shipmentItem.order_item;

    this.state = {
      item_option: this.getItemOption(orderItem, order),
      decimalSymbol: CurrencyHelper.getDecimalSymbol(),
      orderItem: orderItem,
      groupedOrderItems: this.getGroupedOrderItems(order.items, orderItem),
    };
  }

  formatOptionalItemName(name) {
    if (!name || typeof name !== 'string') return null;
    return name.replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
  }

  getOptionalItemsLabel(groupedOrderItems, parentItemId) {
    if (!Array.isArray(groupedOrderItems) || !parentItemId) return null;

    const optionalAttributeSetIds = ['33', '37', '44'];
    const optionalItems = groupedOrderItems
      .filter((item) => {
        if (!item) return false;
        if (item.parent_item_id !== parentItemId) return false;
        if (!optionalAttributeSetIds.includes(item.attribute_set_id)) return false;

        // Em geral, opcionais vêm como produto simples zerado no bundle
        const rawPrice =
          item.price != null ? item.price : item.base_price != null ? item.base_price : 0;
        const price = Number(rawPrice);
        return price === 0;
      })
      .map((item) => this.formatOptionalItemName(item.name))
      .filter(Boolean);

    const uniqueOptionalItems = Array.from(new Set(optionalItems));
    if (!uniqueOptionalItems.length) return null;

    return uniqueOptionalItems.join(', ');
  }

  getGroupedOrderItems(orderItems, orderItem) {
    if (!orderItems || !orderItem) return [];

    // Retorna o item pai + todos os filhos diretos (variações)
    const groupedItems = orderItems.filter((item) => {
      return (
        item.item_id === orderItem.item_id ||
        item.parent_item_id === orderItem.item_id
      );
    });

    return groupedItems;
  }

  getColorFromProductOptions(orderItem) {
    if (!orderItem || !orderItem.product_options) {
      return null;
    }

    let productOptions = orderItem.product_options;

    if (typeof productOptions === 'string') {
      try {
        productOptions = JSON.parse(productOptions);
      } catch (error) {
        return null;
      }
    }

    const attributesInfo = productOptions.attributes_info || [];
    const colorAttribute = attributesInfo.find(
      (attribute) =>
        attribute.label === 'Cor' || attribute.label === 'Color',
    );

    return colorAttribute ? colorAttribute.value : null;
  }

  getValidChildFromGrouped(orderItem, attributeSetId, groupedOrderItems) {
    if (!orderItem || !groupedOrderItems) {
      return null;
    }

    return groupedOrderItems.find(
      (child) =>
        +child.parent_item_id === +orderItem.item_id &&
        +child.parent_item_id !== +child.item_id &&
        child.attribute_set_id === attributeSetId,
    );
  }

  getItemColorValue(orderItem, groupedOrderItems) {
    if (!orderItem) {
      return null;
    }

    const childItem = this.getValidChildFromGrouped(
      orderItem,
      orderItem.attribute_set_id,
      groupedOrderItems,
    );

    if (orderItem.color && typeof orderItem.color === 'string') {
      return orderItem.color;
    }

    if (childItem && childItem.color && typeof childItem.color === 'string') {
      return childItem.color;
    }

    return (
      this.getColorFromProductOptions(orderItem) ||
      this.getColorFromProductOptions(childItem)
    );
  }

  formatItemNameWithColor(orderItem, itemName, itemColor, attributeSetId) {
    if (!['33', '37', '44'].includes(attributeSetId)) {
      return itemName;
    }

    const groupedOrderItems = this.state.groupedOrderItems || [];
    const childItem = orderItem
      ? this.getValidChildFromGrouped(
          orderItem,
          attributeSetId,
          groupedOrderItems,
        )
      : null;
    let baseName = itemName;

    if (orderItem && orderItem.parent_item_id) {
      const parent = groupedOrderItems.find(
        (item) => +item.item_id === +orderItem.parent_item_id,
      );

      if (parent && parent.name) {
        baseName = parent.name;
      }
    }

    if (childItem && childItem.name) {
      baseName = childItem.name;
    }

    if (itemColor) {
      const escapedColor = itemColor.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      baseName = baseName.replace(new RegExp(`[- ]${escapedColor}$`, 'i'), '').trim();

      return `${baseName} - ${itemColor}`;
    }

    if (attributeSetId === '44') {
      const size =
        childItem && childItem.size && typeof childItem.size === 'string'
          ? childItem.size
          : orderItem &&
            orderItem.size &&
            typeof orderItem.size === 'string'
            ? orderItem.size
            : null;

      if (size) {
        const escapedSize = size.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        if (!new RegExp(`[- ]${escapedSize}$`, 'i').test(baseName)) {
          return `${baseName} - ${size}`;
        }
      }
    }

    return baseName;
  }

  getItemOption(orderItem, order) {
    let options = OrderItemService.getOrderItemOptionLabelsAsArray(
      orderItem,
      order,
    );

    if (!options || !options.length) {
      return null;
    }
    return <p className="option">{options.join(', ')}</p>;
  }

  canIncreaseQty = (item) => {
    return item.qty < item.qty_left && !item.disable;
  };

  handleCircleClick = (child, firstPendingItem) => {
    if (child === firstPendingItem) {
      if (child.isMergedItem) {
        child.childrenRefs.forEach((item) => {
          if (this.canIncreaseQty(item)) {
            this.increaseQty(item);
          }
        });
      } else if (this.canIncreaseQty(child)) {
        this.increaseQty(child);
      }

      // Força atualização imediata
      this.forceUpdate();

      // Simula clique no botão diretamente
      const button = document.querySelector('.actions-accept .btn.btn-default');
      if (button) button.click();
    }
  };

  isNodeComplete = (items) => {
    if (!items || items.length !== 2) return false;

    // Durante render inicial
    const bothQtyLeftZero = items.every((item) => item.qty_left === 0);
    if (bothQtyLeftZero) return true;

    // Durante interação (após clique)
    const bothQtyAndLeftOne = items.every(
      (item) => item.qty === 1 && item.qty_left === 1,
    );
    if (bothQtyAndLeftOne) return true;

    return false;
  };

  increaseQty = (child) => {
    const qty = NumberHelper.addNumber(child.qty, 1);
    this.props.updateShipmentItemParam(child, { qty });
  };

  handleShipAll = () => {
    this.props.childrenItems.forEach((child) => {
      if (this.canIncreaseQty(child)) {
        this.increaseQty(child);
      }
    });
  };

  renderTimelineNode(child, index, allItems, firstPendingItem) {
    const isCompleted = child.qty_left === 0;
    const isActive = isCompleted; // Só é ativo quando totalmente concluído
    const isNextItem = child === firstPendingItem;
    const isLastOriginal = index === allItems.length - 1;

    // Nova variável para identificar o último item REAL (não o item falso)
    const isLastRealItem =
      index === allItems.findIndex((item) => item.isCompletedNode) - 1;

    const canClick = isNextItem;

    // Determina o atributo de um item único ou agrupado
    // let attributeSetId = null;
    // if (child.isMergedItem && child.childrenRefs && child.childrenRefs[0]) {
    //   attributeSetId = child.childrenRefs[0].order_item.attribute_set_id;
    // } else {
    //   attributeSetId = child.order_item && child.order_item.attribute_set_id;
    // }

    // let typeLabel = null;
    // if (attributeSetId === "24") {
    //   typeLabel = "inscrição";
    // } else if (child.order_item.product_id === 9266) {
    //   typeLabel = "serviço";
    // } else if (["33", "37", "44"].includes(attributeSetId)) {
    //   typeLabel = "produto";
    // }

    return (
      <div
        className={`timeline-item1 ${isLastOriginal ? 'last' : ''} ${
          isActive ? 'active' : ''
        }`}
        key={`node-${
          (child.order_item && child.order_item.item_id) || 'merged'
        }`}
      >
        <div className="timeline-node-container">
          <div
            className={`timeline-node ${isActive ? 'active' : ''} ${
              isNextItem ? 'next-item' : ''
            }`}
            onClick={() =>
              canClick && this.handleCircleClick(child, firstPendingItem)
            }
            style={{
              backgroundColor: isActive
                ? '#03BC01'
                : isNextItem
                  ? '#03BC01'
                  : '#fff',
              border:
                isActive || isNextItem ? '2px solid #03BC01' : '2px solid #ccc',
              cursor: canClick ? 'pointer' : 'default',
            }}
          >
            {isActive && (
              <svg className="check-icon" viewBox="0 0 24 24">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
              </svg>
            )}
          </div>
        </div>

        {/* Linha conectora com classe adicional para o último item real */}
        {!isLastOriginal && (
          <div
            className={`timeline-connector ${
              isActive ? 'active' : isNextItem ? 'half-active' : ''
            } ${isLastRealItem ? 'last-real-connector' : ''}`} // Classe adicionada aqui
          />
        )}
      </div>
    );
  }

  renderItemContent(child, firstPendingItem, tShirtName, tShirtItem) {
    const isCompleted = child.qty_left === 0;
    const isNextItem = child === firstPendingItem;

    const getStatusInfo = () => {
      if (child.qty_left === 0) {
        return {
          text: 'Concluído',
          class: 'status-concluido',
          content: 'content-green',
        };
      } else if (child === firstPendingItem) {
        return {
          text: 'Dar baixa',
          class: 'status-dar-baixa-verde',
          content: 'content-green',
        };
      } else {
        return {
          text: 'Dar baixa',
          class: 'status-dar-baixa-cinza',
          content: 'content-grey',
        };
      }
    };

    const status = getStatusInfo();

    const getAttributeSetId = () => {
      if (child.isMergedItem && child.childrenRefs && child.childrenRefs[0]) {
        return child.childrenRefs[0].order_item.attribute_set_id;
      }
      return child.order_item && child.order_item.attribute_set_id;
    };

    const attributeSetId = getAttributeSetId();

    const getTypeLabel = () => {
      if (['24', '28'].includes(attributeSetId)) {
        return 'inscrição';
      } else if (
        (['30'].includes(attributeSetId) &&
          tShirtName &&
          typeof tShirtName === 'string') ||
        child.order_item.product_id === 9266
      ) {
        return 'serviço';
      } else if (['33', '37', '44'].includes(attributeSetId)) {
        return 'produto';
      }

      return null;
    };

    const typeLabel = getTypeLabel();

    const customShirtName = 'Personalização de Camiseta';

    const getItemName = () => {
      if (child.isMergedItem && this.state.groupedOrderItems[0]) {
        const firstGroupedItem = this.state.groupedOrderItems[0];

        // Verifica se category_type existe, não é null/undefined e não é booleano
        if (
          firstGroupedItem.category_type &&
          typeof firstGroupedItem.category_type !== 'boolean'
        ) {
          return firstGroupedItem.category_type;
        }

        return firstGroupedItem.name || 'Item Agrupado';
      }

      const hasTShirtNameFromItem =
        tShirtItem &&
        tShirtItem.order_item &&
        typeof tShirtItem.order_item.t_shirt_name === 'string';

      const hasTShirtNameFromGrouped =
        tShirtName && typeof tShirtName === 'string';

      // const hasSizeFromItem =
      //   child.order_item &&
      //   typeof child.order_item.size === 'string' &&
      //   child.order_item.size.trim() !== '';

      if (
        hasTShirtNameFromItem ||
        hasTShirtNameFromGrouped
      ) {
        return customShirtName;
      }

      // Fallback seguro caso order_item venha inconsistente/nulo da API
      return (child.order_item && child.order_item.name) || 'Item';
    };

    // const displayShirtDetail =
    //   (tShirtName && typeof tShirtName === 'string' && tShirtName.trim()) ||
    //   (child.order_item &&
    //     typeof child.order_item.size === 'string' &&
    //     child.order_item.size.trim());

    const itemName = getItemName();
    const itemColor =
      child.order_item && ['33', '37', '44'].includes(attributeSetId)
        ? this.getItemColorValue(
            child.order_item,
            this.state.groupedOrderItems,
          )
        : null;
    const displayName = this.formatItemNameWithColor(
      child.order_item,
      itemName,
      itemColor,
      attributeSetId,
    );

    return (
      <div className="item-content">
        {/* Exibe o typeLabel abaixo da item-content */}
        {typeLabel && (
          <div className={`item-type-label ${status.content}`}>{typeLabel}</div>
        )}

        <div
          className={`item-name ${isCompleted ? 'completed' : ''} ${
            status.content
          }`}
        >
          {displayName}
        </div>

        {/* Exibe o tShirtName quando o item possuir order_item.t_shirt_name */}
        {tShirtName && itemName === customShirtName && (
          <div className={`t-shirt-name ${status.content}`}>{tShirtName}</div>
        )}

        {/* Exibe o detalhe da camiseta (t_shirt_name ou size) quando o item for de camiseta */}
        {/* {displayShirtDetail && itemName === customShirtName && (
         <div className={`t-shirt-name ${status.content}`}>
           {displayShirtDetail}
         </div>
       )} */}

        <div
          className={`item-status ${isCompleted ? 'completed' : ''}`}
          onClick={() =>
            isNextItem && this.handleCircleClick(child, firstPendingItem)
          }
          style={{ cursor: isNextItem ? 'pointer' : 'default' }}
        >
          <span className={status.class}>{status.text}</span>
        </div>
      </div>
    );
  }

  isAllCompleted = () => {
    const { childrenItems } = this.props;
    // const allCompleted = childrenItems.every((child) => child.qty_left === 0);
    // const lastItem = childrenItems[childrenItems.length - 1];
    // const lastItemMarked = lastItem && lastItem.qty === 1;

    return childrenItems.every((child) => child.qty_left === 0);
  };

  template() {
    const { orderItem } = this.state;
    const { childrenItems, order, t } = this.props;

    const showError = !orderItem || !order || !order.items;

    if (showError) {
      return (
        <div className="page-notfound">
          <div className="icon" />
          {t('Pedido nao encontrado.')}
        </div>
      );
    }

    // const allCompleted = childrenItems.every((child) => child.qty_left === 0);

    const participant =
      orderItem.associated_customers && orderItem.associated_customers[0];
    // const tShirtSize = orderItem.options && orderItem.options.tshirt_size;
    const isPrime = participant && participant.group_id === 4;

    const { groupedOrderItems } = this.state;

    let chestNumber = null;
    let distance = null;
    let kitName = null;
    const optionalItemsLabel = this.getOptionalItemsLabel(
      groupedOrderItems,
      orderItem.item_id,
    );
    let tshirtSizes = [];
    let squadColor = null;
    let tShirtName = null; // NOVA VARIÁVEL DINÂMICA

    groupedOrderItems.forEach((item) => {
      // Chest Number e Kit Name
      if (item.attribute_set_id === '23' || item.attribute_set_id === '24') {
        chestNumber = item.additional_data ? item.additional_data : 'Atribuir';

        kitName = item.category_type || item.name;

        if (typeof item.category_type === 'boolean') {
          kitName = item.name;
        }

        if (item.name && item.name.includes('Sacola')) {
          kitName = item.name;
        }

        squadColor = item.ext_order_item_id
          ? item.ext_order_item_id
          : 'Atribuir';
      }

      // Distance
      if (item.attribute_set_id === '28') {
        distance = item.distance || distance;
      }

      // T-Shirt Size
      if (item.attribute_set_id === '27') {
        if (item.size) tshirtSizes.push(item.size);
      }

      // T-Shirt Name
      if (
        item.product_id === 9266 ||
        (item.attribute_set_id === 30 && item.t_shirt_name)
      ) {
        tShirtName = item.t_shirt_name;
      }
    });

    const uniqueTshirtSizes = tshirtSizes ? Array.from(new Set(tshirtSizes)) : [];
    const hasTshirtSizes = uniqueTshirtSizes.length > 0;

    const apparel = hasTshirtSizes ? (
      <div style={{ width: '100%' }}>
        {uniqueTshirtSizes.map((size, idx) => (
          <React.Fragment key={`tshirt-size-${idx}-${size}`}>
            <div>{size}</div>
            {idx < uniqueTshirtSizes.length - 1 && (
              <hr style={{ margin: '8px 0'}} />
            )}
          </React.Fragment>
        ))}
      </div>
    ) : null;

    const getsquadColorStyle = (squadColor) => {
      // Normaliza para título case (primeira letra maiúscula)
      const normalizedColor =
        squadColor.charAt(0).toUpperCase() + squadColor.slice(1).toLowerCase();

      const baseStyle = {
        padding: '22px',
        borderRadius: '60px',
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
        fontSize: '19px',
        gap: '8px',
        textAlign: 'center',
        width: '200px',
        height: '40px',
      };

      switch (normalizedColor) {
        case 'Verde':
          return {
            ...baseStyle,
            backgroundColor: '#03BC01',
            color: 'white',
          };
        case 'Branco':
          return {
            ...baseStyle,
            backgroundColor: 'white',
            color: '#000000',
            border: '1px solid #000000',
          };
        case 'Azul':
          return {
            ...baseStyle,
            backgroundColor: '#01ABF7',
            color: 'white',
          };
        case 'Quênia':
          return {
            ...baseStyle,
            backgroundColor: '#000000',
            color: 'white',
          };
        default:
          return {
            ...baseStyle,
            backgroundColor: 'gray',
            color: 'white',
          };
      }
    };

    //console.log('childrenItems', childrenItems);

    const tShirtItemsAll = childrenItems.filter(
      (item) => item.order_item && item.order_item.t_shirt_name,
    );

    //console.log('tShirtItemsAll', tShirtItemsAll);

    // Pega o primeiro t_shirt_name válido (se houver) e sua referência de item
    const tShirtItem = tShirtItemsAll.length > 0 ? tShirtItemsAll[0] : null;

    //console.log('tShirtItem', tShirtItem);

    // IDs que devem ser agrupados
    // Logica para quando ocorrer a Baixa, agrupar os atributos selecionados que não mostram em tela mas são carregados
    const itemsToMerge = childrenItems.filter(
      (item) =>
        ['27', '28', '31'].includes(item.order_item.attribute_set_id) ||
        (item.order_item.attribute_set_id === '30' &&
          !item.order_item.t_shirt_name) || // 30 só entra se não tiver t_shirt_name
        item.order_item.product_id === 18594,
    );

    // Itens que não devem ser agrupados
    // Logica para não mostrar os atribuitos selecionados na hora de dar baixa
    const otherItems = childrenItems.filter(
      (item) =>
        !(
          ['27', '28', '31'].includes(item.order_item.attribute_set_id) ||
          (item.order_item.attribute_set_id === '30' &&
            !item.order_item.t_shirt_name) || // evita duplicar os mesclados
          item.order_item.product_id === 18594
        ),
    );

    const mergedItem =
      itemsToMerge.length > 0
        ? {
            isMergedItem: true,
            order_item: {
              item_id: 'merged',
              name: itemsToMerge[0].order_item.name || 'Item Agrupado',
              sku: 'AGRUPADO',
            },
            qty: itemsToMerge.reduce((sum, item) => sum + item.qty, 0),
            qty_left: itemsToMerge.reduce(
              (sum, item) => sum + item.qty_left,
              0,
            ),
            childrenRefs: itemsToMerge,
          }
        : null;

    const serviceItem = otherItems.find(
      (item) => item.order_item.product_id === 9266,
    );
    const otherItemsWithoutService = otherItems.filter(
      (item) => item.order_item.product_id !== 9266,
    );

    // Monta array final garantindo que o tShirtItem (se existir) aparece apenas 1 vez ---
    const extendedChildrenItems = [
      ...(mergedItem ? [mergedItem] : []),
      ...(serviceItem ? [serviceItem] : []),
      ...otherItemsWithoutService,
      { isCompletedNode: true },
    ];

    // const para uso posterior
    const firstPendingItem = extendedChildrenItems.find(
      (child) => child.qty_left > 0,
    );

    return (
      <div className="shipment-component">
        {participant && (
          <div className="participant-info">
            <div className="participant-info-left">
              <div className="participant-name">
                <span className="attribute-value">
                  {participant.firstname} {participant.lastname}
                </span>
              </div>
            </div>

            {isPrime && (
              <div
                className={`squad-container ${
                  isPrime ? 'prime-items-background' : ''
                }`}
              ></div>
            )}

            {squadColor && (
              <div
                className="participant-squad"
                style={getsquadColorStyle(squadColor)}
              >
                <span>Pelotão: {squadColor}</span>
              </div>
            )}
          </div>
        )}

        <div className="shipment-summary">
          {chestNumber && (
            <div className="summary-item">
              <div className="summary-label">Número de Peito</div>
              <div className="summary-value">{chestNumber}</div>
            </div>
          )}

          {distance && (
            <div className="summary-item">
              <div className="summary-label">Distância</div>
              <div className="summary-value">{distance}</div>
            </div>
          )}

          {kitName && (
            <div className="summary-item">
              <div className="summary-label">Kit</div>
              <div className="summary-value">
                {kitName}
                {optionalItemsLabel ? ` / ${optionalItemsLabel}` : ''}
              </div>
            </div>
          )}

          {apparel && (
            <div className="summary-item">
              <div className="summary-label">Camiseta</div>
              <div className="summary-value">{apparel}</div>
            </div>
          )}

        </div>

        {/* ✅ Timeline original */}
        <div className="timeline-horizontal-container">
          <div className="timeline-items-container">
            {extendedChildrenItems.map((child, index, allItems) => {
              const key = child.isMergedItem
                ? 'merged'
                : child.order_item && child.order_item.item_id
                  ? child.order_item.item_id
                  : `child-${index}`;

              if (child.isCompletedNode) {
                // Verifica se todos os itens REAIS (excluindo o nó de conclusão) estão completos
                const realItems = extendedChildrenItems.filter(
                  (item) => !item.isCompletedNode,
                );
                const allRealItemsCompleted = realItems.every(
                  (item) => item.qty_left === 0,
                );

                return (
                  <div className="timeline-item2 last" key="completed-node">
                    <div
                      className={`timeline-node ${
                        allRealItemsCompleted ? 'active' : ''
                      }`}
                    >
                      {allRealItemsCompleted && (
                        <svg className="check-icon" viewBox="0 0 24 24">
                          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                        </svg>
                      )}
                    </div>
                    <div className="item-content">
                      <div
                        className={`item-name ${
                          allRealItemsCompleted ? 'completed' : ''
                        }`}
                      >
                        Concluído
                      </div>
                    </div>
                  </div>
                );
              }

              return (
                <div className="timeline-item" key={key}>
                  {this.renderTimelineNode(
                    child,
                    index,
                    allItems,
                    firstPendingItem,
                  )}
                  {/* PASSA tShirtName PARA O renderItemContent */}
                  {this.renderItemContent(
                    child,
                    firstPendingItem,
                    tShirtName,
                    tShirtItem,
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

CreateShipmentItemSeparatelyShipBundleComponent.propTypes = {
  childrenItems: PropTypes.array.isRequired,
  updateShipmentItemParam: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  shipmentItem: PropTypes.object.isRequired,
  decimalSymbol: PropTypes.string.isRequired,
  associatedCustomer: PropTypes.number,
};

export default ContainerFactory.get(CoreContainer).withRouter(
  ComponentFactory.get(CreateShipmentItemSeparatelyShipBundleComponent),
);



// WEBPACK FOOTER //
// ./src/extension/take-shipment/view/component/order/order-detail/create-shipment/CreateShipmentItemSeparatelyShipBundle.js